import React, { useState } from "react";
import OrdersTable from "./OrdersTable";
import OrderDetails from "./OrderDetails";

function OrderManagement() {
  const [showOrderDetails, setShowOrderDetails] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleViewOrder = (order) => {
    setSelectedOrderId(order.id);
    setShowOrderDetails(true);
  };

  const handleCloseDetails = () => {
    setShowOrderDetails(false);
    setSelectedOrderId(null);
  };

  const handleOrderUpdated = () => {
    // Refresh table data and close modal
    setShowOrderDetails(false);
    setRefreshTrigger((prev) => prev + 1);
  };

  return (
    <div>
      <OrdersTable onViewDetails={handleViewOrder} refreshTrigger={refreshTrigger} />

      <OrderDetails
        visible={showOrderDetails}
        orderId={selectedOrderId}
        onClose={handleCloseDetails}
        onStatusUpdate={handleOrderUpdated}
      />
    </div>
  );
}
export default OrderManagement;
